/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FanRemixContestEndingSoonNotificationActionData } from './FanRemixContestEndingSoonNotificationActionData';
import {
    FanRemixContestEndingSoonNotificationActionDataFromJSON,
    FanRemixContestEndingSoonNotificationActionDataFromJSONTyped,
    FanRemixContestEndingSoonNotificationActionDataToJSON,
} from './FanRemixContestEndingSoonNotificationActionData';

/**
 * 
 * @export
 * @interface FanRemixContestEndingSoonNotificationAction
 */
export interface FanRemixContestEndingSoonNotificationAction {
    /**
     * 
     * @type {string}
     * @memberof FanRemixContestEndingSoonNotificationAction
     */
    specifier: string;
    /**
     * 
     * @type {string}
     * @memberof FanRemixContestEndingSoonNotificationAction
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof FanRemixContestEndingSoonNotificationAction
     */
    timestamp: number;
    /**
     * 
     * @type {FanRemixContestEndingSoonNotificationActionData}
     * @memberof FanRemixContestEndingSoonNotificationAction
     */
    data: FanRemixContestEndingSoonNotificationActionData;
}

/**
 * Check if a given object implements the FanRemixContestEndingSoonNotificationAction interface.
 */
export function instanceOfFanRemixContestEndingSoonNotificationAction(value: object): value is FanRemixContestEndingSoonNotificationAction {
    let isInstance = true;
    isInstance = isInstance && "specifier" in value && value["specifier"] !== undefined;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "timestamp" in value && value["timestamp"] !== undefined;
    isInstance = isInstance && "data" in value && value["data"] !== undefined;

    return isInstance;
}

export function FanRemixContestEndingSoonNotificationActionFromJSON(json: any): FanRemixContestEndingSoonNotificationAction {
    return FanRemixContestEndingSoonNotificationActionFromJSONTyped(json, false);
}

export function FanRemixContestEndingSoonNotificationActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): FanRemixContestEndingSoonNotificationAction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'specifier': json['specifier'],
        'type': json['type'],
        'timestamp': json['timestamp'],
        'data': FanRemixContestEndingSoonNotificationActionDataFromJSON(json['data']),
    };
}

export function FanRemixContestEndingSoonNotificationActionToJSON(value?: FanRemixContestEndingSoonNotificationAction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'specifier': value.specifier,
        'type': value.type,
        'timestamp': value.timestamp,
        'data': FanRemixContestEndingSoonNotificationActionDataToJSON(value.data),
    };
}

